export default "__VITE_PUBLIC_ASSET__01a01cf9__"